import Logs from '../components/logsComponent/Logs'

const LogsPage = () => {
    return (
        <Logs />
    )
}

export default LogsPage
